/**
 * M07-calendar
 *
 * @param   {object}        options - overwrites default settings (optional)
 *
 * */

import Vue from 'vue/dist/vue.min.js';
import isotope from 'vueisotope';
import VueI18n from 'vue-i18n';

import filterModel from '../components/calendar/filter-model';
import filterHelper from '../components/calendar/filter-helper';
import filterData from '../components/calendar/filter-data';
import filterUi from '../components/calendar/filter-ui';
import filterQuery from '../components/calendar/filter-query';
import calendarTile from '../components/calendar/calendar-tile';
import calendarLayout from '../components/calendar/calendar-layout';

import eventDetail from '../vue-components/event-detail/event-detail.vue';

import calendarNavigation from '../modules/m07-2-calendar-mobile.js';
import debounce from 'debounce';
import resizeManager from '../helpers/resize-manager';


let instance = {},
    settings = {},
    defaults = {
        mainElement: '.m-calendar',
        initialFilterAttr: 'data-initial-filter',
        filterDataUrl: window.DS.apis.calendarData + '?lang=' + window.DS.lang,
        queryAmount: 1,
        queryStep: 1,
        prevAmount: 500,
        scrollDuration: 360,
        scrollEasing: 'easeInOutCubic',
        scrollDelta: 250, // amount of visible pixels under the tile to be opened, otherwise scroll to
        defaultDate: Math.round((new Date().getTime() / 1000) - 3 * 24 * 60 * 60), // now minus 3 days
        grid: {
            2800: {
                itemsOnRow: 10,
                initalRows: 2,
                moreRows: 2
            },
            2500: {
                itemsOnRow: 9,
                initalRows: 2,
                moreRows: 2
            },
            2200: {
                itemsOnRow: 8,
                initalRows: 2,
                moreRows: 2
            },
            1920: {
                itemsOnRow: 7,
                initalRows: 3,
                moreRows: 2
            },
            1400: {
                itemsOnRow: 6,
                initalRows: 2,
                moreRows: 2
            },
            1128: {
                itemsOnRow: 5,
                initalRows: 2,
                moreRows: 2
            },
            860: {
                itemsOnRow: 4,
                initalRows: 2,
                moreRows: 2
            },
            568: {
                itemsOnRow: 3,
                initalRows: 2,
                moreRows: 2
            },
            0: {
                itemsOnRow: 2,
                initalRows: 2,
                moreRows: 2
            }
        },
        classes: {
            viewbox: 'calendar-viewbox',
            tile: 'calendarTile'
        },
        modifier: {
            viewboxlist: 'calendar-viewbox--list'
        },
        isotope: {
            layouts: [
                'fitRows',
                'vertical'
            ],
            transitionDuration: '0.5s',
            currentLayout: 'fitRows',
            sortMapping: {
                index: 'index'
            },
            sort: 'index'
        }
    },

    // main module element
    mainElement,

    // vue object
    /* eslint-disable */
    calendar,
    /* eslint-enable */

    // map methods
    methodObj = {
        setFilter: filterUi.setFilter,
        callFilter: filterQuery.callFilter,
        debouncedCallFilter: debounce(filterQuery.callFilter, 400),
        showDetail: filterUi.showDetail,
        openNav: filterUi.openNav,
        closeNav: filterUi.openNav,
        closeAllSublevels: filterUi.closeAllSublevels,
        closeAllSublevelsOnFilter: filterUi.closeAllSublevelsOnFilter,
        resetFilter: filterUi.resetFilter,
        resetFilterGroups: filterUi.resetFilterGroups,
        checkFirstLevelBehaviour: filterUi.checkFirstLevelBehaviour,
        fetchAjaxData: filterData.fetchAjaxData,
        fetchQueryData: filterData.fetchQueryData,
        fetchStorageData: filterData.fetchStorageData,
        getDay: filterHelper.getDay,
        getMonth: filterHelper.getMonth,
        getYear: filterHelper.getYear,
        getBreakpoint: filterHelper.getBreakpoint,
        getTranslation: filterHelper.getTranslation,
        triggerTile: calendarTile.triggerTile,
        openTile: calendarTile.openTile,
        closeTile: calendarTile.closeTile,
        stamp: calendarTile.stamp,
        setTileStyles: calendarTile.setTileStyles,
        closeAllTiles: calendarTile.closeAllTiles,
        changeLayout: calendarLayout.changeLayout,
        sort: calendarLayout.sort,
        btoa: (str) => window.btoa(str),
        getTimestampFromYear: filterHelper.getTimestampFromYear,
        getTimestampFromMonth: filterHelper.getTimestampFromMonth,
        debugDate: filterHelper.debugDate,
        oneDayDiff: filterHelper.oneDayDiff,
        resize: filterHelper.resize,
        clearSearch () {
            this.stringsearch = '';
            this.debouncedCallFilter();
        },
        eventDetailLoaded: function () {
            // detail ready
        }
    },

    initData = () => {
        return {
            ready: false,
            uiready: false,
            layouts: filterModel.settings.isotope.layouts,
            filtercloud: [],
            list: [],
            items: window.filterConfig,
            keymap: window.filtermap,
            query: {},
            isTimespanQuery: false,
            listview: filterModel.settings.isotope.currentLayout === 'vertical',
            hasmore: false,
            loadernext: false,
            loaderprev: false,
            moreAmount: 0,
            prevAmount: 0,
            actQueryAmount: 0,
            actQueryOffset: 0,
            queryAmount: filterModel.settings.queryAmount,
            queryStep: filterModel.settings.queryStep,
            itemsOnRow: 0,
            querydata: [],
            stringsearch: '',
            currentLayout: {
                layoutMode: filterModel.settings.isotope.currentLayout
            },
            sortOption: filterModel.settings.isotope.sort,
            option: {
                itemSelector: '.' + filterModel.settings.classes.tile,
                layoutMode: filterModel.settings.isotope.currentLayout,
                transitionDuration: filterModel.settings.isotope.transitionDuration,
                getSortData: filterModel.settings.isotope.sortMapping,
                sortBy: filterModel.settings.isotope.sort
            }
        };
    },

    fire = (calendarData) => {
        let initialFilters = [];

        Vue.component('isotope', isotope);
        Vue.component('event-detail', eventDetail);

        // register i18n plugin
        Vue.use(VueI18n);

        // set language
        Vue.config.lang = window.DS.lang;

        // add translations
        Vue.locale(window.DS.lang, window.DS.translations);

        // Check for predefined filter
        if (mainElement.hasAttribute(settings.initialFilterAttr)) {
            initialFilters = mainElement.getAttribute(settings.initialFilterAttr) !== '' && mainElement.getAttribute(settings.initialFilterAttr).split(',');
        }

        calendar = new Vue({
            el: filterModel.settings.mainElement,
            data: calendarData,
            delimiters: ['[[', ']]'],
            methods: methodObj,
            created() {

                // set ui ready state
                this.uiready = true;

                this.hasInitialFilter = initialFilters.length > 0;

                // set object to model
                filterModel.calendar = this;

                // get breakpoint
                this.getBreakpoint();
            },
            mounted() {
                filterModel.resizeWidth = document.documentElement.clientWidth;

                resizeManager.add(this.resize);

                // start mobile nav
                calendarNavigation.init({
                    moduleId: 'calendar-navigation',
                    navClass: 'mobilenav',
                    calendarInstance: this
                });

                if (this.hasInitialFilter) {
                    // Very quick'n'dirty solution to set intitial filter settings.
                    // Not sure if there's a nicer way.
                    for (let i = initialFilters.length; i--;) {
                        document.getElementById(initialFilters[i]).click();
                    }
                } else {
                    this.fetchAjaxData(filterModel.settings.filterDataUrl);
                }

            },
            watch: {
                filtercloud: filterQuery.triggerCallFilter
            }
        });
    };

instance.init = (options) => {
    let calendarModel,
        initialView;

    // Get main element
    mainElement = document.querySelector('.m-calendar');
    if (!mainElement) return false;

    // iOS10 zoom fix
    document.documentElement.addEventListener('gesturestart', function (event) {
        event.preventDefault();
    }, false);

    if (window.filterConfig === undefined) {
        console.error('m07-2 no filterconfig found');
        return false;
    }

    if (window.filtermap === undefined) {
        console.error('m07-2 no filtermap found');
        return false;
    }

    // Merge default settings
    settings = Object.assign({}, defaults, options);

    // Get initial view
    if (typeof(Storage) !== undefined && localStorage.getItem('calendar-current-layout')) {
        initialView = localStorage.getItem('calendar-current-layout');
    } else {
        initialView = mainElement.hasAttribute('data-initial-view') ?  mainElement.getAttribute('data-initial-view') : 'tiles';
    }

    if (initialView === 'list') {
        settings.isotope.currentLayout = 'vertical';
    }

    // Set filterModel
    filterModel.settings = settings;
    filterModel.mainElement = mainElement;

    // Set calendar data
    calendarModel = initData();

    // Start calendar
    fire(calendarModel);
};

export default instance;

